import Controller, { OnClose, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { ThemeService, ThemeTonalRange } from '@philips-internal/oswald-ui-components';
import BaseController from '../BaseController';
import { APPLICATION_ROUTES } from '../../constants/application-routes';
import './index.css';

@Controller({ fragment: 'new-user-by-login-modal', component: 'modal-new-user-by-login' })
export default class NewUserByLoginModalController extends BaseController {

  @OnMount({ target: 'modal-new-user-by-login' })
  changeTheme(): void {
    ThemeService.setContentTonalRange(ThemeTonalRange.ULTRA_LIGHT);
  }

  @OnClose({ target: 'modal-new-user-by-login' })
  onCloseModalAccountCreation(): void {
    this.historyService.push(APPLICATION_ROUTES.USERS);
  }
}
